export default "__VITE_ASSET__37HKkLjn__"